import React from 'react';

import Button from '@atlaskit/button/default/button';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
import { PopupTrigger } from '@atlassian/entry-points/popup-trigger';

import { errorPopupEntryPoint } from '../fixtures/constellation/error-popup-entry-point';
import { RelayWrapper } from '../utils/wrapper';

function CustomError(): React.JSX.Element {
	return (
		<Box padding="space.200">
			<Stack space="space.100" role="alert">
				<Text weight="bold">Popup content is unavailable</Text>
				<Text>This example failed on purpose. Dismiss the popup to continue.</Text>
			</Stack>
		</Box>
	);
}

export default function PopupTriggerCustomError(): React.JSX.Element {
	return (
		<RelayWrapper>
			<PopupTrigger
				entryPoint={errorPopupEntryPoint}
				role="dialog"
				label="Custom error popup"
				placement="bottom-start"
				loadingText="Loading popup content"
				loadingCompleteText="Loading finished"
				errorFallback={CustomError}
				trigger={(triggerProps) => (
					<Button {...triggerProps} appearance="primary" isSelected={triggerProps['aria-expanded']}>
						{triggerProps['aria-expanded'] ? 'Close popup' : 'Show custom error'}
					</Button>
				)}
				shouldRenderToParent
			/>
		</RelayWrapper>
	);
}
